"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RTCExample = void 0;
var tslib_1 = require("tslib");
var Subscribe_1 = require("../shared-utils/Subscribe");
var RTCProtocol_1 = require("../typings/RTCProtocol");
/**
 * RTCExample。
 */
var RTCExample = /** @class */ (function (_super) {
    (0, tslib_1.__extends)(RTCExample, _super);
    function RTCExample() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.joined = false;
        _this.micro = false;
        _this.voiceId = '';
        _this.type = RTCProtocol_1.RTCType.realsee;
        return _this;
    }
    RTCExample.prototype.join = function (options) {
        throw new Error('Method not implemented.');
    };
    RTCExample.prototype.quit = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                return [2 /*return*/, true];
            });
        });
    };
    RTCExample.prototype.detectMicro = function () {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                return [2 /*return*/, true];
            });
        });
    };
    RTCExample.prototype.toggleMicro = function (flag) {
        return (0, tslib_1.__awaiter)(this, void 0, void 0, function () {
            return (0, tslib_1.__generator)(this, function (_a) {
                return [2 /*return*/, true];
            });
        });
    };
    RTCExample.prototype.shock = function () {
        // throw new Error('Method not implemented.')
    };
    return RTCExample;
}(Subscribe_1.Subscribe));
exports.RTCExample = RTCExample;
//# sourceMappingURL=index.js.map